/**
 * The rung of what a send carries, as the composer reasons about it.
 *
 * Plain TypeScript, no React import. Since kitecorp/transferify#525 every plan includes the look, so nothing
 * here asks for a plan or names a credit: the only question left is what is actually going out.
 */
import type {PersonalizationRung} from "./personalizationDraft";

/**
 * The rung of what is GOING OUT, which is not always the rung of what was composed.
 *
 * <b>A DISABLED draft carries nothing, whatever it contains.</b> `toPersonalizationRequest` answers
 * `null` for one, so a draft the sender dismissed reaches the api as no personalization at all, while
 * {@link ./personalizationDraft.personalizationDraftRung} still reports `branding`, because it describes
 * the DRAFT rather than the send. The rung rides with the request to the success screen
 * ({@link ./successPersonalization.personalizationRungSettles}), so reading the composed rung would tell it a
 * branded look was attached when nothing was, and close its Personalise entry on a plain transfer.
 */
export function outgoingPersonalizationRung(
	enabled: boolean,
	composedRung: PersonalizationRung,
): PersonalizationRung {
	return enabled ? composedRung : "empty";
}
